import { Component } from '@angular/core';
import {
  AlertController, LoadingController, ModalController, NavController, NavParams, Platform,
  ToastController, ViewController
} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import {Storage} from "@ionic/storage";

@Component({
  selector: 'page-total-no-oe-en-q-report-all-school',
  templateUrl: 'total-no-oe-en-q-report-all-school.html',
})
export class TotalNoOeEnQReportAllSchoolPage {

  School = 'GWW';
  SchoolData = {};
  Data:any;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public service: ServiceProvider,
              public platform: Platform,
              public loadingCtrl: LoadingController,
              public toastCtrl: ToastController,
              public storage: Storage,
              public viewCtrl: ViewController,
              public modalCtrl: ModalController,
              public alertCtrl: AlertController) {


    this.platform.ready().then(() => {

      this.SchoolData = {
        "All": 0,
        "GWW": 2,
        "GWE": 3,
        "GEIS": 1
      };

      this.loadDataCount(this.SchoolData[this.School]);

    });


  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad TotalNoOeEnQReportAllSchoolPage');
  }


  active_tab(tab) {
    console.log(tab);
    this.School = tab;
    this.loadDataCount(this.SchoolData[this.School]);

  }


  loadDataCount(FSchoolId) {

    this.Data = [];

    const loader = this.loadingCtrl.create({
      content: "Please wait...",
      duration: 10000
    });
    loader.present();

    this.service.httpcall('app_web_service/get_total_noOFEnquiry_report?FSchoolId=' + FSchoolId).subscribe(data => {
      console.log(data);
      this.Data = data;
      loader.dismiss();

    })



  }



  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.loadDataCount(this.SchoolData[this.School]);

    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

  backBTN() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/total-no-oe-en-q-report-all-school/total-no-oe-en-q-report-all-school.ts